import * as types from "./types"
import http from "@/utils/http"
// 轻提示
import { Toast } from 'vant';

let state = {
    parkList: [],
    allLoad: false, // 加载完成
    isLoad: true, // 正在加载
    noData: false, // 暂无数据
    pageSize: 6
}
// 异步任务
let actions = {
    [types.PARKINGPUBLICQUERY](context, params) {
        http.post('p-ypt-parkingPublic-query', params).then(data => {
            context.commit(types.PARKINGPUBLICQUERY, data)
        })
    }
}
// 同步任务
let mutations = {
    [types.PARKINGPUBLICQUERY](state, data) {
        state.isLoad = true
        if (data.code==='ok') {
            state.isLoad = false
            let index = data.data
            if (index.totalPage != 0) { // 进行分页
                if (index.dataList.length >= 1) {
                    state.parkList = state.parkList.concat(index.dataList)
                } else {
                    state.allLoad = true
                }
            } else { // 暂无数据
                state.noData = true
            }
        } else {
            state.isLoad = false
            Toast(data.message)
        }
    },
    // 重置参数设备列表 分页参数
    RESETPARKPARAMS(state, data) {
        state.noData = false
        state.allLoad = false
        state.isLoad = true
        // 清空累加的数据
        state.parkList = []
    },
}

export default { state, actions, mutations }



// WEBPACK FOOTER //
// ./src/store/parking/index.js